export default {
    'Monday': 'Понеділок',
    'Tuesday': 'Вівторок',
    'Wednesday': 'Середа',
    'Thursday': 'Четвер',
    'Friday': "П'ятниця",
    'Saturday': 'Субота',
    'Sunday': 'Неділя',

    'Mo': 'Пн',
    'Tu': 'Вт',
    'We': 'Ср',
    'Th': 'Чт',
    'Fr': 'Пт',
    'Sa': 'Сб',
    'Su': 'Нд',

    'January': 'Січень',
    'February': 'Лютий',
    'March': 'Березень',
    'April': 'Квітень',
    'May': 'Травень',
    'June': 'Червень',
    'July': 'Липень',
    'August': 'Серпень',
    'September': 'Вересень',
    'October': 'Жовтень',
    'November': 'Листопад',
    'December': 'Грудень',

    'Jan': 'Січ',
    'Feb': 'Лют',
    'March': 'Бер',
    'Apr': 'Квіт',
    'May': 'Трав',
    'June': 'Чер',
    'July': 'Лип',
    'Aug': 'Сер',
    'Sept': 'Вер',
    'Oct': 'Жов',
    'Nov': 'Лист',
    'Dec': 'Груд',
};
